"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditReviewStatus = void 0;
/**
 * Edit Review Status
 */
var EditReviewStatus;
(function (EditReviewStatus) {
    EditReviewStatus["PENDING"] = "pending";
    EditReviewStatus["PROCESSING"] = "processing";
    EditReviewStatus["COMPLETED"] = "completed";
    EditReviewStatus["FAILED"] = "failed";
})(EditReviewStatus || (exports.EditReviewStatus = EditReviewStatus = {}));
//# sourceMappingURL=edit-review-types.js.map